//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { RadioGroup, RadioOption } from 'unison';

import { ConnectPanelActions } from '@catalog-ingestion/actions/connectPanelActions';
import { ICuralateStore } from '@models/AppState';
import styled from 'styled-components';
import { ReduxDispatch } from 'app/curalate.store';

function mapStateToProps(state: ICuralateStore) {
  return {
    connectionMethod:
      state.catalogIngestionReducers.connectPanel.connectionMethod,
  };
}

function mapDispatchToProps(dispatch: ReduxDispatch) {
  return {
    actions: {
      connectPanel: bindActionCreators(ConnectPanelActions, dispatch),
    },
  };
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

export const RadioButtonField = (props: Props) => {
  const {
    connectionMethod,
    actions: {
      connectPanel: { changeConnectionMethod },
    },
  } = props;

  return (
    <>
      <div className='cu-text-subsection cu-pb-1'>
        Select a Connection Method
      </div>
      <RadioButtonWrapper
        handleChange={changeConnectionMethod}
        value={connectionMethod}
      >
        <RadioButton value='CatalogURL' className='cu-radio-option-longform'>
          <div className='cu-m-2'>
            <div className='cu-text-subsection'>Use a link (recommended)</div>
            <div className='cu-text-body'>
              This is the recommended method to connect your product catalog.
              Once connected, we will check this link multiple times a day for
              updates to your product catalog.
            </div>
          </div>
        </RadioButton>
        <RadioButton value='FileUpload' className='cu-radio-option-longform'>
          <div className='cu-m-2'>
            <div className='cu-text-subsection'>
              Upload a file (not recommended)
            </div>
            <div className='cu-text-body'>
              If you do not have a link to your product feed, upload your file.
              However, if you choose to upload a file, you will need to get
              Bazaarvoice Support to upload a new file manually each time there
              is an update to your product catalog.
            </div>
          </div>
        </RadioButton>
      </RadioButtonWrapper>
    </>
  );
};

const RadioButtonWrapper = styled(RadioGroup)`
  && {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: ${({ theme }) => theme.spacings['3']};
  }
`;

const RadioButton = styled(RadioOption)`
  && {
    margin-right: ${({ theme }) => theme.spacings['0']};
  }
  height: 100%;
`;

export default connect(mapStateToProps, mapDispatchToProps)(RadioButtonField);
